import { addNodesInTree } from '../../../components/Tree/helpers/helpers';
import { arrayify } from '../../../utils/array/array';
import { selectTreeDataByTreeId, updateData } from '../../selectors/tree/tree';

export const addNodes = (tree, nodes, options) => async (dispatch, getState) => {
  const currentTreeData = selectTreeDataByTreeId(getState(), tree);
  const nodesToAdd = arrayify(nodes);
  const result = addNodesInTree(nodesToAdd, currentTreeData, options);
  return dispatch(updateData(tree, result.treeData));
};
